'use client'
import React from 'react'
import useDeviceType from '@/hook/useDeviceType'
const BlogMainImage = ({ banner, mobBanner, alt }) => {
    const deviceType = useDeviceType()
    const img = deviceType === 'mobile' ? mobBanner : banner
    return (
        <div>
            <img src={img} alt={alt} />
        </div>
    )
}

export default BlogMainImage